import React, { useState, useRef, useEffect } from "react"
import { BookOpen } from "lucide-react"
import { Typography, Button, Badge, Input, message, useCRUDController, Row, Col, Card, Select, Divider } from "../../ui/ot"
import dayjs from 'dayjs';
import { BadgeInfo } from 'lucide-react';
import { ChartCirculationStatscard } from "./chart_circulation_statscard"
import { ChartOverdueDaysDistribution } from './chart_overdue_days_distribution'
import { ChartOverdueMonthlyTrend } from './chart_overdue_monthly_trend'
import { TableBranchOverdueStatistics } from './table_branch_overdue_statistics'
import { OverdueProcessingTable } from "./overdue_processing";
const basicFilterSetting = ["branchcode", 'itemtype']

const OverdueReport = ({
    filterSearchParams = [...basicFilterSetting]

}) => {
    const [searchParams, setSearchParams] = useState({
        item_type: null,
        branchcode: null,
        keyword: null
    })
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const itemtypeController = useCRUDController({ apiRoute: "/koha/itemtypes" })
    useEffect(() => {
        libraryController.getData({})
        itemtypeController.getData({})
    }, []);
    return (<Row gutter={[4, 4]}>
        <Col span={24}>
            <Row align="middle">
                <Col>
                    <BookOpen className="h-5 w-5" />
                </Col>
                <Col>
                    <Typography.Title level={4}>
                        逾期報表
                    </Typography.Title>
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Row gutter={[4, 4]}>
                <Col span={24}>
                    <Row >
                        {filterSearchParams.includes("branchcode") ? <Col>
                            <Row align={"middle"} gutter={[8, 8]}>
                                <Col>
                                    分館篩選：
                                </Col>
                                <Col>
                                    <Select
                                        allowClear={true}
                                        defaultValue={searchParams?.branchcode}
                                        value={searchParams?.branchcode}
                                        onChange={(value) => {
                                            setSearchParams((pre) => {
                                                return {
                                                    ...pre,
                                                    branchcode: value
                                                }
                                            })
                                        }}
                                        options={libraryController?.ResponseData?.map((option) => {
                                            return {
                                                label: `(${option?.branchcode})${option?.branchname}`,
                                                value: option?.branchcode,
                                            }
                                        })}
                                    >
                                    </Select>
                                </Col>
                            </Row>
                        </Col> : <></>}
                        {filterSearchParams.includes("itemtype") ? <Col>
                            <Row align={"middle"} gutter={[8, 8]}>
                                <Col>
                                    館藏分類篩選：
                                </Col>
                                <Col>
                                    <Select
                                        allowClear={true}
                                        defaultValue={searchParams?.itemtype}
                                        value={searchParams?.itemtype}
                                        onChange={(value) => {
                                            setSearchParams((pre) => {
                                                return {
                                                    ...pre,
                                                    item_type: value
                                                }
                                            })
                                        }}
                                        options={itemtypeController?.ResponseData?.map((option) => {
                                            return {
                                                label: `(${option?.itemtype})${option?.description}`,
                                                value: option?.itemtype,
                                            }
                                        })}
                                    >
                                    </Select>
                                </Col>
                            </Row>
                        </Col> : <></>}
                    </Row>
                </Col>
                <Col span={24}>
                    <Row align="middle" gutter={[4, 4]}>
                        <Col>
                            <BadgeInfo size={16} />
                        </Col>
                        <Col>
                            <Typography.P>
                                圖書逾期情況統計
                            </Typography.P>
                        </Col>
                    </Row>
                </Col>
                <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                    <ChartCirculationStatscard
                        propsDataParams={{
                            ...searchParams
                        }}
                        apiRoute="/koha/report/overdue/total"
                         rowKey="overdues"
                        getLabel={(data) => {
                            return `逾期總數:${data?.overdues_increase} 較上月`
                        }}
                    />

                </Col>
                <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                    <ChartCirculationStatscard
                        propsDataParams={{
                            ...searchParams
                        }}
                        apiRoute="/koha/report/overdue/rate"
                        rowKey="this_month_rate"
                        propsColor="#f09a45"
                        getLabel={(data) => {
                            return `逾期率:${data?.rate_change}較上月`
                        }}
                    />
                </Col>
                <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                    <ChartCirculationStatscard
                        propsDataParams={{
                            ...searchParams
                        }}
                        apiRoute="/koha/report/overdue/average"
                        rowKey="average_overdue_days"
                        getLabel={(data) => {
                            return `平均逾期天數 `
                        }}
                    />
                </Col>
                
            </Row>
        </Col>
        <Col span={24}>
            <Row gutter={[4, 4]}>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                    <Card
                        title={"逾期天數分布"}
                        extra={"按逾期天數區間統計的圖書數量"}
                    >
                        <ChartOverdueDaysDistribution />
                    </Card>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                    <Card
                        title={"逾期月度趨勢"}
                        extra={"在時間區段中逾期數量與逾期率變化"}
                    >
                        <ChartOverdueMonthlyTrend />
                    </Card>
                </Col>
            </Row>
        </Col>
        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
            <Card title={"分館逾期統計"} >
                <TableBranchOverdueStatistics />
            </Card>
        </Col>
         <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
            <Card title={"逾期詳細資料"} >
                <OverdueProcessingTable  propsIssueDaysDueStatus={"已逾期"}   />
            </Card>
        </Col>
        
    </Row>)
}
export { OverdueReport }